import React from 'react';
import ReactDOM from 'react-dom';

import {createHashHistory} from 'history';

import {Router, Route, useRouterHistory} from 'react-router'

import {syncHistoryWithStore,RouterStore} from 'mobx-react-router';

import {Provider} from 'mobx-react';

import ListDoing from './components/ListDoing'
import { WeaPopoverHrm } from 'ecCom';

import Cowork from 'weaCowork' //umd
//import Workflow from './index'
import {IndexRedirect} from 'react-router';
const CoworkStore = Cowork.store;
const routing = new RouterStore();
const CoworkRoute = Cowork.Route;
import {WeaLocaleProvider} from 'ecCom';
import CoworkSingle from './components/CoworkSingle';
import "./style/single.less";
let stores = {
  // Key can be whatever you want
  routing:routing,
  ...CoworkStore
}

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, stores.routing);

class Home extends React.Component {
  render() {
    return (
      <div className="h100">
        <WeaLocaleProvider>
        {this.props.children}
        </WeaLocaleProvider>
        <WeaPopoverHrm />
      </div>
    );
  }
}
const getLocaleLabel = WeaLocaleProvider.getLocaleLabel.bind(this, 'cowork');

class Root extends React.Component {
  render() {
    return (
      <Provider {...stores}>
        <Router history={history}>
          <Route path="/"  onEnter={getLocaleLabel} component={Home}>
            <Route name="main" breadcrumbName="入口" path="main">
              {CoworkRoute}
            </Route>
            <Route name="cowork" path="cowork/:coworkId" component={CoworkSingle}>
              <Route path=":floorNum"/>
            </Route>
            <IndexRedirect to="main/cowork/main"></IndexRedirect>
          </Route>
        </Router>
      </Provider>
    )
  }
}

ReactDOM.render(<Root/>, document.getElementById('container'));



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/single.js